
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { MembershipFormData } from "../types";

interface PotatoAreaFieldsProps {
  form: UseFormReturn<MembershipFormData>;
}

export const PotatoAreaFields = ({ form }: PotatoAreaFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="currentPotatoArea"
        render={({ field }) => (
          <FormItem>
            <FormLabel>What area of seed potatoes do you usually grow? (ha)</FormLabel>
            <FormControl>
              <Input 
                {...field} 
                type="number" 
                value={field.value || ''} 
                onChange={(e) => field.onChange(e.target.value)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="totalPotatoArea"
        render={({ field }) => (
          <FormItem>
            <FormLabel>What is the total area of potatoes (seed and ware)?</FormLabel>
            <FormControl>
              <Input 
                {...field} 
                type="number" 
                value={field.value || ''} 
                onChange={(e) => field.onChange(e.target.value)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="plannedPotatoArea"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              If your area will change next year please specify
            </FormLabel>
            <FormControl>
              <Input 
                {...field} 
                type="number" 
                value={field.value || ''} 
                onChange={(e) => field.onChange(e.target.value)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
